import { G } from '@mobily/ts-belt'

export const pushDataLayer = (...data: DataLayerEvent[]) => {
  if (G.isNotNullable(dataLayer) && G.isArray(dataLayer)) {
    dataLayer.push(...data)
  }
}
